"use client";

import { lazyComponent } from "@/components/ui/lazy-component";
import { LoadFailureNotice } from "@/components/ui/load-failure-notice";

export const FitSceneDynamic = lazyComponent(
  () => import("./fit-scene").then((module) => module.FitScene),
  {
    ssr: false,
    loading: (
      <div className="flex h-[420px] items-center justify-center bg-card border border-border">
        <p className="text-sm text-muted-foreground">Loading 3D preview...</p>
      </div>
    ),
    failure: {
      label: "truck-fit-scene",
      fallback: (
        <LoadFailureNotice
          title="The 3D preview could not load."
          className="h-[420px]"
        />
      ),
    },
  },
);
